export const currencyOptions = [
  { value: 'NGN', label: 'Nigerian Naira (NGN)' },
  { value: 'USD', label: 'US Dollar (USD)' },
  { value: 'EUR', label: 'Euro (EUR)' },
  { value: 'GBP', label: 'British Pound (GBP)' },
  { value: 'CAD', label: 'Canadian Dollar (CAD)' },
  { value: 'AUD', label: 'Australian Dollar (AUD)' },
  { value: 'GHS', label: 'Ghanaian Cedi (GHS)' },
  { value: 'KES', label: 'Kenyan Shilling (KES)' },
];

export const fontOptions = [
  { value: 'AlbertSans-Regular, sans-serif', label: 'Albert Sans Regular' },
  { value: 'AlbertSans-Medium, sans-serif', label: 'Albert Sans Medium' },
  { value: 'AlbertSans-SemiBold, sans-serif', label: 'Albert Sans SemiBold' },
  { value: 'AlbertSans-Bold, sans-serif', label: 'Albert Sans Bold' },
  { value: 'Inter, sans-serif', label: 'Inter Regular' },
  { value: 'PassionOne-Regular, sans-serif', label: 'Passion One Regular' },
  { value: 'PassionOne-Bold, sans-serif', label: 'Passion One Bold' },
  { value: 'PassionOne-Black, sans-serif', label: 'Passion One Black' },
  { value: 'Sora-Regular, sans-serif', label: 'Sora Regular' },
  { value: 'Sora-Light, sans-serif', label: 'Sora Light' },
  { value: 'Helvetica, sans-serif', label: 'Helvetica (System)' },
  { value: 'Arial, sans-serif', label: 'Arial (System)' },
];

export const defaultColors = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#96CEB4', // Green
  '#FECA57', // Yellow
  '#FF9FF3', // Pink
  '#54A0FF', // Light Blue
  '#5F27CD', // Purple
  '#00D2D3', // Cyan
  '#FF9F43', // Orange
  '#00C9FF', // Sky Blue
  '#8C7CF0', // Lavender
];
